/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * train-with-me
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  DeleteNutritionMeEntriesEntryKeyParams,
  DeleteNutritionMeMealsMealKeyParams,
  GetNutritionCustomersCustomerIdDayParams,
  GetNutritionCustomersCustomerIdRangeParams,
  GetNutritionMeDayParams,
  GetNutritionMeRangeParams,
  GetNutritionMeRecentFoodsParams,
  MicrosoftAspNetCoreMvcProblemDetails,
  TrainWithMeModulesNutritionDtosRequestsPutNutritionEntryRequest,
  TrainWithMeModulesNutritionDtosRequestsPutNutritionMealItemRequest,
  TrainWithMeModulesNutritionDtosRequestsPutNutritionMealRequest,
  TrainWithMeModulesNutritionDtosRequestsPutNutritionTargetRequest,
  TrainWithMeModulesNutritionDtosResponsesNutritionCalculatorInputsResponse,
  TrainWithMeModulesNutritionDtosResponsesNutritionDayResponse,
  TrainWithMeModulesNutritionDtosResponsesNutritionProductResponse,
  TrainWithMeModulesNutritionDtosResponsesNutritionRangeResponse,
  TrainWithMeModulesNutritionDtosResponsesNutritionRecentFoodsResponse,
  TrainWithMeModulesNutritionDtosResponsesNutritionTargetResponse
} from '../../model';

import { customInstance } from '../../../mutator';
import type { ErrorType , BodyType } from '../../../mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getNutritionCustomersCustomerIdCalculatorInputs = (
    customerId: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesNutritionDtosResponsesNutritionCalculatorInputsResponse>(
      {url: `/nutrition/customers/${customerId}/calculator-inputs`, method: 'GET', signal
    },
      options);
    }




export const getGetNutritionCustomersCustomerIdCalculatorInputsQueryKey = (customerId: number,) => {
    return [
    `/nutrition/customers/${customerId}/calculator-inputs`
    ] as const;
    }


export const getGetNutritionCustomersCustomerIdCalculatorInputsQueryOptions = <TData = Awaited<ReturnType<typeof getNutritionCustomersCustomerIdCalculatorInputs>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(customerId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNutritionCustomersCustomerIdCalculatorInputs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNutritionCustomersCustomerIdCalculatorInputsQueryKey(customerId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNutritionCustomersCustomerIdCalculatorInputs>>> = ({ signal }) => getNutritionCustomersCustomerIdCalculatorInputs(customerId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: customerId !== null && customerId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNutritionCustomersCustomerIdCalculatorInputs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetNutritionCustomersCustomerIdCalculatorInputsQueryResult = NonNullable<Awaited<ReturnType<typeof getNutritionCustomersCustomerIdCalculatorInputs>>>
export type GetNutritionCustomersCustomerIdCalculatorInputsQueryError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>


export function useGetNutritionCustomersCustomerIdCalculatorInputs<TData = Awaited<ReturnType<typeof getNutritionCustomersCustomerIdCalculatorInputs>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 customerId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNutritionCustomersCustomerIdCalculatorInputs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNutritionCustomersCustomerIdCalculatorInputs>>,
          TError,
          Awaited<ReturnType<typeof getNutritionCustomersCustomerIdCalculatorInputs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNutritionCustomersCustomerIdCalculatorInputs<TData = Awaited<ReturnType<typeof getNutritionCustomersCustomerIdCalculatorInputs>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 customerId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNutritionCustomersCustomerIdCalculatorInputs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNutritionCustomersCustomerIdCalculatorInputs>>,
          TError,
          Awaited<ReturnType<typeof getNutritionCustomersCustomerIdCalculatorInputs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNutritionCustomersCustomerIdCalculatorInputs<TData = Awaited<ReturnType<typeof getNutritionCustomersCustomerIdCalculatorInputs>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 customerId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNutritionCustomersCustomerIdCalculatorInputs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetNutritionCustomersCustomerIdCalculatorInputs<TData = Awaited<ReturnType<typeof getNutritionCustomersCustomerIdCalculatorInputs>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 customerId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNutritionCustomersCustomerIdCalculatorInputs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetNutritionCustomersCustomerIdCalculatorInputsQueryOptions(customerId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getNutritionCustomersCustomerIdDay = (
    customerId: number,
    params?: GetNutritionCustomersCustomerIdDayParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesNutritionDtosResponsesNutritionDayResponse>(
      {url: `/nutrition/customers/${customerId}/day`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetNutritionCustomersCustomerIdDayQueryKey = (customerId: number,
    params?: GetNutritionCustomersCustomerIdDayParams,) => {
    return [
    `/nutrition/customers/${customerId}/day`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetNutritionCustomersCustomerIdDayQueryOptions = <TData = Awaited<ReturnType<typeof getNutritionCustomersCustomerIdDay>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(customerId: number,
    params?: GetNutritionCustomersCustomerIdDayParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNutritionCustomersCustomerIdDay>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNutritionCustomersCustomerIdDayQueryKey(customerId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNutritionCustomersCustomerIdDay>>> = ({ signal }) => getNutritionCustomersCustomerIdDay(customerId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: customerId !== null && customerId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNutritionCustomersCustomerIdDay>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetNutritionCustomersCustomerIdDayQueryResult = NonNullable<Awaited<ReturnType<typeof getNutritionCustomersCustomerIdDay>>>
export type GetNutritionCustomersCustomerIdDayQueryError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>


export function useGetNutritionCustomersCustomerIdDay<TData = Awaited<ReturnType<typeof getNutritionCustomersCustomerIdDay>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 customerId: number,
    params: undefined |  GetNutritionCustomersCustomerIdDayParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNutritionCustomersCustomerIdDay>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNutritionCustomersCustomerIdDay>>,
          TError,
          Awaited<ReturnType<typeof getNutritionCustomersCustomerIdDay>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNutritionCustomersCustomerIdDay<TData = Awaited<ReturnType<typeof getNutritionCustomersCustomerIdDay>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 customerId: number,
    params?: GetNutritionCustomersCustomerIdDayParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNutritionCustomersCustomerIdDay>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNutritionCustomersCustomerIdDay>>,
          TError,
          Awaited<ReturnType<typeof getNutritionCustomersCustomerIdDay>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNutritionCustomersCustomerIdDay<TData = Awaited<ReturnType<typeof getNutritionCustomersCustomerIdDay>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 customerId: number,
    params?: GetNutritionCustomersCustomerIdDayParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNutritionCustomersCustomerIdDay>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetNutritionCustomersCustomerIdDay<TData = Awaited<ReturnType<typeof getNutritionCustomersCustomerIdDay>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 customerId: number,
    params?: GetNutritionCustomersCustomerIdDayParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNutritionCustomersCustomerIdDay>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetNutritionCustomersCustomerIdDayQueryOptions(customerId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getNutritionCustomersCustomerIdRange = (
    customerId: number,
    params?: GetNutritionCustomersCustomerIdRangeParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesNutritionDtosResponsesNutritionRangeResponse>(
      {url: `/nutrition/customers/${customerId}/range`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetNutritionCustomersCustomerIdRangeQueryKey = (customerId: number,
    params?: GetNutritionCustomersCustomerIdRangeParams,) => {
    return [
    `/nutrition/customers/${customerId}/range`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetNutritionCustomersCustomerIdRangeQueryOptions = <TData = Awaited<ReturnType<typeof getNutritionCustomersCustomerIdRange>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(customerId: number,
    params?: GetNutritionCustomersCustomerIdRangeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNutritionCustomersCustomerIdRange>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNutritionCustomersCustomerIdRangeQueryKey(customerId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNutritionCustomersCustomerIdRange>>> = ({ signal }) => getNutritionCustomersCustomerIdRange(customerId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: customerId !== null && customerId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNutritionCustomersCustomerIdRange>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetNutritionCustomersCustomerIdRangeQueryResult = NonNullable<Awaited<ReturnType<typeof getNutritionCustomersCustomerIdRange>>>
export type GetNutritionCustomersCustomerIdRangeQueryError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>


export function useGetNutritionCustomersCustomerIdRange<TData = Awaited<ReturnType<typeof getNutritionCustomersCustomerIdRange>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 customerId: number,
    params: undefined |  GetNutritionCustomersCustomerIdRangeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNutritionCustomersCustomerIdRange>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNutritionCustomersCustomerIdRange>>,
          TError,
          Awaited<ReturnType<typeof getNutritionCustomersCustomerIdRange>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNutritionCustomersCustomerIdRange<TData = Awaited<ReturnType<typeof getNutritionCustomersCustomerIdRange>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 customerId: number,
    params?: GetNutritionCustomersCustomerIdRangeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNutritionCustomersCustomerIdRange>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNutritionCustomersCustomerIdRange>>,
          TError,
          Awaited<ReturnType<typeof getNutritionCustomersCustomerIdRange>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNutritionCustomersCustomerIdRange<TData = Awaited<ReturnType<typeof getNutritionCustomersCustomerIdRange>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 customerId: number,
    params?: GetNutritionCustomersCustomerIdRangeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNutritionCustomersCustomerIdRange>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetNutritionCustomersCustomerIdRange<TData = Awaited<ReturnType<typeof getNutritionCustomersCustomerIdRange>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 customerId: number,
    params?: GetNutritionCustomersCustomerIdRangeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNutritionCustomersCustomerIdRange>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetNutritionCustomersCustomerIdRangeQueryOptions(customerId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getNutritionCustomersCustomerIdTarget = (
    customerId: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesNutritionDtosResponsesNutritionTargetResponse>(
      {url: `/nutrition/customers/${customerId}/target`, method: 'GET', signal
    },
      options);
    }




export const getGetNutritionCustomersCustomerIdTargetQueryKey = (customerId: number,) => {
    return [
    `/nutrition/customers/${customerId}/target`
    ] as const;
    }


export const getGetNutritionCustomersCustomerIdTargetQueryOptions = <TData = Awaited<ReturnType<typeof getNutritionCustomersCustomerIdTarget>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(customerId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNutritionCustomersCustomerIdTarget>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNutritionCustomersCustomerIdTargetQueryKey(customerId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNutritionCustomersCustomerIdTarget>>> = ({ signal }) => getNutritionCustomersCustomerIdTarget(customerId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: customerId !== null && customerId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNutritionCustomersCustomerIdTarget>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetNutritionCustomersCustomerIdTargetQueryResult = NonNullable<Awaited<ReturnType<typeof getNutritionCustomersCustomerIdTarget>>>
export type GetNutritionCustomersCustomerIdTargetQueryError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>


export function useGetNutritionCustomersCustomerIdTarget<TData = Awaited<ReturnType<typeof getNutritionCustomersCustomerIdTarget>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 customerId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNutritionCustomersCustomerIdTarget>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNutritionCustomersCustomerIdTarget>>,
          TError,
          Awaited<ReturnType<typeof getNutritionCustomersCustomerIdTarget>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNutritionCustomersCustomerIdTarget<TData = Awaited<ReturnType<typeof getNutritionCustomersCustomerIdTarget>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 customerId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNutritionCustomersCustomerIdTarget>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNutritionCustomersCustomerIdTarget>>,
          TError,
          Awaited<ReturnType<typeof getNutritionCustomersCustomerIdTarget>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNutritionCustomersCustomerIdTarget<TData = Awaited<ReturnType<typeof getNutritionCustomersCustomerIdTarget>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 customerId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNutritionCustomersCustomerIdTarget>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetNutritionCustomersCustomerIdTarget<TData = Awaited<ReturnType<typeof getNutritionCustomersCustomerIdTarget>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 customerId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNutritionCustomersCustomerIdTarget>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetNutritionCustomersCustomerIdTargetQueryOptions(customerId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const putNutritionCustomersCustomerIdTarget = (
    customerId: number,
    trainWithMeModulesNutritionDtosRequestsPutNutritionTargetRequest?: BodyType<TrainWithMeModulesNutritionDtosRequestsPutNutritionTargetRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesNutritionDtosResponsesNutritionTargetResponse>(
      {url: `/nutrition/customers/${customerId}/target`, method: 'PUT',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesNutritionDtosRequestsPutNutritionTargetRequest, signal
    },
      options);
    }




export const getPutNutritionCustomersCustomerIdTargetMutationOptions = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putNutritionCustomersCustomerIdTarget>>, TError,{customerId: number;data?: BodyType<TrainWithMeModulesNutritionDtosRequestsPutNutritionTargetRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putNutritionCustomersCustomerIdTarget>>, TError,{customerId: number;data?: BodyType<TrainWithMeModulesNutritionDtosRequestsPutNutritionTargetRequest>}, TContext> => {

const mutationKey = ['putNutritionCustomersCustomerIdTarget'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putNutritionCustomersCustomerIdTarget>>, {customerId: number;data?: BodyType<TrainWithMeModulesNutritionDtosRequestsPutNutritionTargetRequest>}> = (props) => {
          const {customerId,data} = props ?? {};

          return  putNutritionCustomersCustomerIdTarget(customerId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutNutritionCustomersCustomerIdTargetMutationResult = NonNullable<Awaited<ReturnType<typeof putNutritionCustomersCustomerIdTarget>>>
    export type PutNutritionCustomersCustomerIdTargetMutationBody = BodyType<TrainWithMeModulesNutritionDtosRequestsPutNutritionTargetRequest> | undefined
    export type PutNutritionCustomersCustomerIdTargetMutationError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>

    export const usePutNutritionCustomersCustomerIdTarget = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putNutritionCustomersCustomerIdTarget>>, TError,{customerId: number;data?: BodyType<TrainWithMeModulesNutritionDtosRequestsPutNutritionTargetRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putNutritionCustomersCustomerIdTarget>>,
        TError,
        {customerId: number;data?: BodyType<TrainWithMeModulesNutritionDtosRequestsPutNutritionTargetRequest>},
        TContext
      > => {
      return useMutation(getPutNutritionCustomersCustomerIdTargetMutationOptions(options), queryClient);
    }
    export const getNutritionMeDay = (
    params?: GetNutritionMeDayParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesNutritionDtosResponsesNutritionDayResponse>(
      {url: `/nutrition/me/day`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetNutritionMeDayQueryKey = (params?: GetNutritionMeDayParams,) => {
    return [
    `/nutrition/me/day`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetNutritionMeDayQueryOptions = <TData = Awaited<ReturnType<typeof getNutritionMeDay>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(params?: GetNutritionMeDayParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNutritionMeDay>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNutritionMeDayQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNutritionMeDay>>> = ({ signal }) => getNutritionMeDay(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNutritionMeDay>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetNutritionMeDayQueryResult = NonNullable<Awaited<ReturnType<typeof getNutritionMeDay>>>
export type GetNutritionMeDayQueryError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>


export function useGetNutritionMeDay<TData = Awaited<ReturnType<typeof getNutritionMeDay>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 params: undefined |  GetNutritionMeDayParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNutritionMeDay>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNutritionMeDay>>,
          TError,
          Awaited<ReturnType<typeof getNutritionMeDay>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNutritionMeDay<TData = Awaited<ReturnType<typeof getNutritionMeDay>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 params?: GetNutritionMeDayParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNutritionMeDay>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNutritionMeDay>>,
          TError,
          Awaited<ReturnType<typeof getNutritionMeDay>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNutritionMeDay<TData = Awaited<ReturnType<typeof getNutritionMeDay>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 params?: GetNutritionMeDayParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNutritionMeDay>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetNutritionMeDay<TData = Awaited<ReturnType<typeof getNutritionMeDay>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 params?: GetNutritionMeDayParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNutritionMeDay>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetNutritionMeDayQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const deleteNutritionMeEntriesEntryKey = (
    entryKey: string,
    params?: DeleteNutritionMeEntriesEntryKeyParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesNutritionDtosResponsesNutritionDayResponse>(
      {url: `/nutrition/me/entries/${entryKey}`, method: 'DELETE',
        params, signal
    },
      options);
    }




export const getDeleteNutritionMeEntriesEntryKeyMutationOptions = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteNutritionMeEntriesEntryKey>>, TError,{entryKey: string;params?: DeleteNutritionMeEntriesEntryKeyParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteNutritionMeEntriesEntryKey>>, TError,{entryKey: string;params?: DeleteNutritionMeEntriesEntryKeyParams}, TContext> => {

const mutationKey = ['deleteNutritionMeEntriesEntryKey'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteNutritionMeEntriesEntryKey>>, {entryKey: string;params?: DeleteNutritionMeEntriesEntryKeyParams}> = (props) => {
          const {entryKey,params} = props ?? {};

          return  deleteNutritionMeEntriesEntryKey(entryKey,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteNutritionMeEntriesEntryKeyMutationResult = NonNullable<Awaited<ReturnType<typeof deleteNutritionMeEntriesEntryKey>>>

    export type DeleteNutritionMeEntriesEntryKeyMutationError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>

    export const useDeleteNutritionMeEntriesEntryKey = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteNutritionMeEntriesEntryKey>>, TError,{entryKey: string;params?: DeleteNutritionMeEntriesEntryKeyParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteNutritionMeEntriesEntryKey>>,
        TError,
        {entryKey: string;params?: DeleteNutritionMeEntriesEntryKeyParams},
        TContext
      > => {
      return useMutation(getDeleteNutritionMeEntriesEntryKeyMutationOptions(options), queryClient);
    }
    export const putNutritionMeEntriesEntryKey = (
    entryKey: string,
    trainWithMeModulesNutritionDtosRequestsPutNutritionEntryRequest?: BodyType<TrainWithMeModulesNutritionDtosRequestsPutNutritionEntryRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesNutritionDtosResponsesNutritionDayResponse>(
      {url: `/nutrition/me/entries/${entryKey}`, method: 'PUT',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesNutritionDtosRequestsPutNutritionEntryRequest, signal
    },
      options);
    }




export const getPutNutritionMeEntriesEntryKeyMutationOptions = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putNutritionMeEntriesEntryKey>>, TError,{entryKey: string;data?: BodyType<TrainWithMeModulesNutritionDtosRequestsPutNutritionEntryRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putNutritionMeEntriesEntryKey>>, TError,{entryKey: string;data?: BodyType<TrainWithMeModulesNutritionDtosRequestsPutNutritionEntryRequest>}, TContext> => {

const mutationKey = ['putNutritionMeEntriesEntryKey'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putNutritionMeEntriesEntryKey>>, {entryKey: string;data?: BodyType<TrainWithMeModulesNutritionDtosRequestsPutNutritionEntryRequest>}> = (props) => {
          const {entryKey,data} = props ?? {};

          return  putNutritionMeEntriesEntryKey(entryKey,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutNutritionMeEntriesEntryKeyMutationResult = NonNullable<Awaited<ReturnType<typeof putNutritionMeEntriesEntryKey>>>
    export type PutNutritionMeEntriesEntryKeyMutationBody = BodyType<TrainWithMeModulesNutritionDtosRequestsPutNutritionEntryRequest> | undefined
    export type PutNutritionMeEntriesEntryKeyMutationError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>

    export const usePutNutritionMeEntriesEntryKey = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putNutritionMeEntriesEntryKey>>, TError,{entryKey: string;data?: BodyType<TrainWithMeModulesNutritionDtosRequestsPutNutritionEntryRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putNutritionMeEntriesEntryKey>>,
        TError,
        {entryKey: string;data?: BodyType<TrainWithMeModulesNutritionDtosRequestsPutNutritionEntryRequest>},
        TContext
      > => {
      return useMutation(getPutNutritionMeEntriesEntryKeyMutationOptions(options), queryClient);
    }
    export const deleteNutritionMeMealsMealKey = (
    mealKey: string,
    params?: DeleteNutritionMeMealsMealKeyParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesNutritionDtosResponsesNutritionDayResponse>(
      {url: `/nutrition/me/meals/${mealKey}`, method: 'DELETE',
        params, signal
    },
      options);
    }




export const getDeleteNutritionMeMealsMealKeyMutationOptions = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteNutritionMeMealsMealKey>>, TError,{mealKey: string;params?: DeleteNutritionMeMealsMealKeyParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteNutritionMeMealsMealKey>>, TError,{mealKey: string;params?: DeleteNutritionMeMealsMealKeyParams}, TContext> => {

const mutationKey = ['deleteNutritionMeMealsMealKey'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteNutritionMeMealsMealKey>>, {mealKey: string;params?: DeleteNutritionMeMealsMealKeyParams}> = (props) => {
          const {mealKey,params} = props ?? {};

          return  deleteNutritionMeMealsMealKey(mealKey,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteNutritionMeMealsMealKeyMutationResult = NonNullable<Awaited<ReturnType<typeof deleteNutritionMeMealsMealKey>>>

    export type DeleteNutritionMeMealsMealKeyMutationError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>

    export const useDeleteNutritionMeMealsMealKey = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteNutritionMeMealsMealKey>>, TError,{mealKey: string;params?: DeleteNutritionMeMealsMealKeyParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteNutritionMeMealsMealKey>>,
        TError,
        {mealKey: string;params?: DeleteNutritionMeMealsMealKeyParams},
        TContext
      > => {
      return useMutation(getDeleteNutritionMeMealsMealKeyMutationOptions(options), queryClient);
    }
    export const putNutritionMeMealsMealKey = (
    mealKey: string,
    trainWithMeModulesNutritionDtosRequestsPutNutritionMealRequest?: BodyType<TrainWithMeModulesNutritionDtosRequestsPutNutritionMealRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesNutritionDtosResponsesNutritionDayResponse>(
      {url: `/nutrition/me/meals/${mealKey}`, method: 'PUT',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesNutritionDtosRequestsPutNutritionMealRequest, signal
    },
      options);
    }




export const getPutNutritionMeMealsMealKeyMutationOptions = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putNutritionMeMealsMealKey>>, TError,{mealKey: string;data?: BodyType<TrainWithMeModulesNutritionDtosRequestsPutNutritionMealRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putNutritionMeMealsMealKey>>, TError,{mealKey: string;data?: BodyType<TrainWithMeModulesNutritionDtosRequestsPutNutritionMealRequest>}, TContext> => {

const mutationKey = ['putNutritionMeMealsMealKey'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putNutritionMeMealsMealKey>>, {mealKey: string;data?: BodyType<TrainWithMeModulesNutritionDtosRequestsPutNutritionMealRequest>}> = (props) => {
          const {mealKey,data} = props ?? {};

          return  putNutritionMeMealsMealKey(mealKey,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutNutritionMeMealsMealKeyMutationResult = NonNullable<Awaited<ReturnType<typeof putNutritionMeMealsMealKey>>>
    export type PutNutritionMeMealsMealKeyMutationBody = BodyType<TrainWithMeModulesNutritionDtosRequestsPutNutritionMealRequest> | undefined
    export type PutNutritionMeMealsMealKeyMutationError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>

    export const usePutNutritionMeMealsMealKey = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putNutritionMeMealsMealKey>>, TError,{mealKey: string;data?: BodyType<TrainWithMeModulesNutritionDtosRequestsPutNutritionMealRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putNutritionMeMealsMealKey>>,
        TError,
        {mealKey: string;data?: BodyType<TrainWithMeModulesNutritionDtosRequestsPutNutritionMealRequest>},
        TContext
      > => {
      return useMutation(getPutNutritionMeMealsMealKeyMutationOptions(options), queryClient);
    }
    export const putNutritionMeMealsMealKeyItemsEntryKey = (
    mealKey: string,
    entryKey: string,
    trainWithMeModulesNutritionDtosRequestsPutNutritionMealItemRequest?: BodyType<TrainWithMeModulesNutritionDtosRequestsPutNutritionMealItemRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesNutritionDtosResponsesNutritionDayResponse>(
      {url: `/nutrition/me/meals/${mealKey}/items/${entryKey}`, method: 'PUT',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesNutritionDtosRequestsPutNutritionMealItemRequest, signal
    },
      options);
    }




export const getPutNutritionMeMealsMealKeyItemsEntryKeyMutationOptions = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putNutritionMeMealsMealKeyItemsEntryKey>>, TError,{mealKey: string;entryKey: string;data?: BodyType<TrainWithMeModulesNutritionDtosRequestsPutNutritionMealItemRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putNutritionMeMealsMealKeyItemsEntryKey>>, TError,{mealKey: string;entryKey: string;data?: BodyType<TrainWithMeModulesNutritionDtosRequestsPutNutritionMealItemRequest>}, TContext> => {

const mutationKey = ['putNutritionMeMealsMealKeyItemsEntryKey'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putNutritionMeMealsMealKeyItemsEntryKey>>, {mealKey: string;entryKey: string;data?: BodyType<TrainWithMeModulesNutritionDtosRequestsPutNutritionMealItemRequest>}> = (props) => {
          const {mealKey,entryKey,data} = props ?? {};

          return  putNutritionMeMealsMealKeyItemsEntryKey(mealKey,entryKey,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutNutritionMeMealsMealKeyItemsEntryKeyMutationResult = NonNullable<Awaited<ReturnType<typeof putNutritionMeMealsMealKeyItemsEntryKey>>>
    export type PutNutritionMeMealsMealKeyItemsEntryKeyMutationBody = BodyType<TrainWithMeModulesNutritionDtosRequestsPutNutritionMealItemRequest> | undefined
    export type PutNutritionMeMealsMealKeyItemsEntryKeyMutationError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>

    export const usePutNutritionMeMealsMealKeyItemsEntryKey = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putNutritionMeMealsMealKeyItemsEntryKey>>, TError,{mealKey: string;entryKey: string;data?: BodyType<TrainWithMeModulesNutritionDtosRequestsPutNutritionMealItemRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putNutritionMeMealsMealKeyItemsEntryKey>>,
        TError,
        {mealKey: string;entryKey: string;data?: BodyType<TrainWithMeModulesNutritionDtosRequestsPutNutritionMealItemRequest>},
        TContext
      > => {
      return useMutation(getPutNutritionMeMealsMealKeyItemsEntryKeyMutationOptions(options), queryClient);
    }
    export const getNutritionMeRange = (
    params?: GetNutritionMeRangeParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesNutritionDtosResponsesNutritionRangeResponse>(
      {url: `/nutrition/me/range`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetNutritionMeRangeQueryKey = (params?: GetNutritionMeRangeParams,) => {
    return [
    `/nutrition/me/range`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetNutritionMeRangeQueryOptions = <TData = Awaited<ReturnType<typeof getNutritionMeRange>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(params?: GetNutritionMeRangeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNutritionMeRange>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNutritionMeRangeQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNutritionMeRange>>> = ({ signal }) => getNutritionMeRange(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNutritionMeRange>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetNutritionMeRangeQueryResult = NonNullable<Awaited<ReturnType<typeof getNutritionMeRange>>>
export type GetNutritionMeRangeQueryError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>


export function useGetNutritionMeRange<TData = Awaited<ReturnType<typeof getNutritionMeRange>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 params: undefined |  GetNutritionMeRangeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNutritionMeRange>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNutritionMeRange>>,
          TError,
          Awaited<ReturnType<typeof getNutritionMeRange>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNutritionMeRange<TData = Awaited<ReturnType<typeof getNutritionMeRange>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 params?: GetNutritionMeRangeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNutritionMeRange>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNutritionMeRange>>,
          TError,
          Awaited<ReturnType<typeof getNutritionMeRange>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNutritionMeRange<TData = Awaited<ReturnType<typeof getNutritionMeRange>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 params?: GetNutritionMeRangeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNutritionMeRange>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetNutritionMeRange<TData = Awaited<ReturnType<typeof getNutritionMeRange>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 params?: GetNutritionMeRangeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNutritionMeRange>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetNutritionMeRangeQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getNutritionMeRecentFoods = (
    params?: GetNutritionMeRecentFoodsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesNutritionDtosResponsesNutritionRecentFoodsResponse>(
      {url: `/nutrition/me/recent-foods`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetNutritionMeRecentFoodsQueryKey = (params?: GetNutritionMeRecentFoodsParams,) => {
    return [
    `/nutrition/me/recent-foods`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetNutritionMeRecentFoodsQueryOptions = <TData = Awaited<ReturnType<typeof getNutritionMeRecentFoods>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(params?: GetNutritionMeRecentFoodsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNutritionMeRecentFoods>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNutritionMeRecentFoodsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNutritionMeRecentFoods>>> = ({ signal }) => getNutritionMeRecentFoods(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNutritionMeRecentFoods>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetNutritionMeRecentFoodsQueryResult = NonNullable<Awaited<ReturnType<typeof getNutritionMeRecentFoods>>>
export type GetNutritionMeRecentFoodsQueryError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>


export function useGetNutritionMeRecentFoods<TData = Awaited<ReturnType<typeof getNutritionMeRecentFoods>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 params: undefined |  GetNutritionMeRecentFoodsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNutritionMeRecentFoods>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNutritionMeRecentFoods>>,
          TError,
          Awaited<ReturnType<typeof getNutritionMeRecentFoods>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNutritionMeRecentFoods<TData = Awaited<ReturnType<typeof getNutritionMeRecentFoods>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 params?: GetNutritionMeRecentFoodsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNutritionMeRecentFoods>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNutritionMeRecentFoods>>,
          TError,
          Awaited<ReturnType<typeof getNutritionMeRecentFoods>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNutritionMeRecentFoods<TData = Awaited<ReturnType<typeof getNutritionMeRecentFoods>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 params?: GetNutritionMeRecentFoodsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNutritionMeRecentFoods>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetNutritionMeRecentFoods<TData = Awaited<ReturnType<typeof getNutritionMeRecentFoods>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 params?: GetNutritionMeRecentFoodsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNutritionMeRecentFoods>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetNutritionMeRecentFoodsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getNutritionMeTarget = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesNutritionDtosResponsesNutritionTargetResponse>(
      {url: `/nutrition/me/target`, method: 'GET', signal
    },
      options);
    }




export const getGetNutritionMeTargetQueryKey = () => {
    return [
    `/nutrition/me/target`
    ] as const;
    }


export const getGetNutritionMeTargetQueryOptions = <TData = Awaited<ReturnType<typeof getNutritionMeTarget>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNutritionMeTarget>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNutritionMeTargetQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNutritionMeTarget>>> = ({ signal }) => getNutritionMeTarget(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNutritionMeTarget>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetNutritionMeTargetQueryResult = NonNullable<Awaited<ReturnType<typeof getNutritionMeTarget>>>
export type GetNutritionMeTargetQueryError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>


export function useGetNutritionMeTarget<TData = Awaited<ReturnType<typeof getNutritionMeTarget>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNutritionMeTarget>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNutritionMeTarget>>,
          TError,
          Awaited<ReturnType<typeof getNutritionMeTarget>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNutritionMeTarget<TData = Awaited<ReturnType<typeof getNutritionMeTarget>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNutritionMeTarget>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNutritionMeTarget>>,
          TError,
          Awaited<ReturnType<typeof getNutritionMeTarget>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNutritionMeTarget<TData = Awaited<ReturnType<typeof getNutritionMeTarget>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNutritionMeTarget>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetNutritionMeTarget<TData = Awaited<ReturnType<typeof getNutritionMeTarget>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNutritionMeTarget>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetNutritionMeTargetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getNutritionProductsBarcodeCode = (
    code: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesNutritionDtosResponsesNutritionProductResponse>(
      {url: `/nutrition/products/barcode/${code}`, method: 'GET', signal
    },
      options);
    }




export const getGetNutritionProductsBarcodeCodeQueryKey = (code: string,) => {
    return [
    `/nutrition/products/barcode/${code}`
    ] as const;
    }


export const getGetNutritionProductsBarcodeCodeQueryOptions = <TData = Awaited<ReturnType<typeof getNutritionProductsBarcodeCode>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNutritionProductsBarcodeCode>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNutritionProductsBarcodeCodeQueryKey(code);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNutritionProductsBarcodeCode>>> = ({ signal }) => getNutritionProductsBarcodeCode(code, requestOptions, signal);





   return  { queryKey, queryFn, enabled: code !== null && code !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNutritionProductsBarcodeCode>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetNutritionProductsBarcodeCodeQueryResult = NonNullable<Awaited<ReturnType<typeof getNutritionProductsBarcodeCode>>>
export type GetNutritionProductsBarcodeCodeQueryError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>


export function useGetNutritionProductsBarcodeCode<TData = Awaited<ReturnType<typeof getNutritionProductsBarcodeCode>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 code: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNutritionProductsBarcodeCode>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNutritionProductsBarcodeCode>>,
          TError,
          Awaited<ReturnType<typeof getNutritionProductsBarcodeCode>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNutritionProductsBarcodeCode<TData = Awaited<ReturnType<typeof getNutritionProductsBarcodeCode>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNutritionProductsBarcodeCode>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNutritionProductsBarcodeCode>>,
          TError,
          Awaited<ReturnType<typeof getNutritionProductsBarcodeCode>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNutritionProductsBarcodeCode<TData = Awaited<ReturnType<typeof getNutritionProductsBarcodeCode>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNutritionProductsBarcodeCode>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetNutritionProductsBarcodeCode<TData = Awaited<ReturnType<typeof getNutritionProductsBarcodeCode>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNutritionProductsBarcodeCode>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetNutritionProductsBarcodeCodeQueryOptions(code,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






